import { render, staticRenderFns } from "./dani.vue?vue&type=template&id=d25a28c4&scoped=true&"
var script = {}
import style0 from "./dani.vue?vue&type=style&index=0&id=d25a28c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25a28c4",
  null
  
)

export default component.exports